// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Grid, Box, Card, Typography, Button } from '@mui/material';
import { MdOutlineMailLock } from 'react-icons/md';
import { HiShieldCheck } from 'react-icons/hi';

import Logo from 'src/layouts/full/shared/logo/Logo';
import PageContainer from 'src/components/container/PageContainer';
import { Link } from 'react-router-dom';

const EmailVerifiedPage = () => (
  <PageContainer title="Change Email" description="this is Change Email page" sx={{ height: '100vh', bgcolor: 'primary.light' }}>
    <Box sx={{ ml: 3, position: 'absolute' }}>
      <Logo align={'start'} />
    </Box>
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Grid container spacing={0} justifyContent="center" alignItems={'center'}>
        <Grid
          display="flex"
          justifyContent="center"
          alignItems="center"
          size={{
            xs: 12,
            sm: 12,
            lg: 4,
            xl: 3
          }}>
          <Card elevation={2} sx={{ p: 8, zIndex: 1, width: '100%', maxWidth: '600px', minWidth: '400px' }}>
            <Box sx={{ color: 'primary.main', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
              <HiShieldCheck size={56} />
            </Box>
            <Typography color="textSecondary" textAlign="center" variant="h4" fontWeight="800" sx={{ mb: 2 }}>
              Email Verified Successfully
            </Typography>
            <Typography color="textSecondary" textAlign="start" variant="body1" sx={{ mb: 2, mt: 4, lineHeight: 1.5, whiteSpace: 'break-spaces', fontSize: 'medium' }}>
              Thank you for verifying. Your account email address is not updated successfully!
            </Typography>
            <Box mt={'48px'}>
              <Button color="primary" variant="contained" size="large" fullWidth component={Link} to={'/auth/login'} aria-label="Confirm button">
                Back to login
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  </PageContainer>
);

export default EmailVerifiedPage;
